// extracted by mini-css-extract-plugin
module.exports = {"section_1":"style_section_1__2Fpgq","section_1_title":"style_section_1_title__u8KM4","data_list":"style_data_list__1VA_G"};